module.exports = __webpack_public_path__ + "static/img/no_data.af0dc185.svg";